import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 1366 213",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_5_160)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1419.09 171.995L1283.81 -473.992L-54.1282 -193.814L-6.44954 33.8669C162.616 7.47866 164.772 104.252 339.248 103.701C475.473 103.291 504.528 40.6291 611.281 68.0514C718.042 95.5103 722.457 223.136 859.835 212.361C997.25 201.578 1020.46 102.434 1157.88 91.6516C1295.29 80.8688 1250.06 198.376 1419.13 171.988",
    fill: "#4B291D"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_5_160" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "1366",
      height: "213",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }